import { useTranslation } from "react-i18next";

import { Button, FormatCurrencyForDisplay } from "@unified-checkout/design-system";
import { Check } from "@unified-checkout/design-system/icons/index";

import type { IPaymobProPricingCard } from "@app/dashboard/types/innerLayout/paymob_pro/paymob-pro-pricing-card";

import styles from "./pricing-card.module.scss";

export const PricingCard = ({
  title,
  subtitle,
  icon,
  iconVariant,
  description,
  note,
  prices,
  includes,
  planType,
  recommended,
  hideCheckIcon
}: IPaymobProPricingCard) => {
  const { t } = useTranslation();

  return (
    <div className={styles['card']} data-card-recommended={recommended}>
      <div className={styles['card__content']}>
        <div className={styles['card__content__header']}>
          <div className={styles['card__content__header__icon']} data-icon-variant={iconVariant}>
            {typeof icon === 'string' ? <img src={icon} alt={title} /> : icon}
          </div>
          <div className={styles['card__content__header__title']}>
            {title}
          </div>
          <div className={styles['card__content__header__subtitle']}>
            {subtitle}
          </div>
        </div>
        <div className={styles['card__content__body']}>
          <div className={styles['card__content__body__price']}>
            {FormatCurrencyForDisplay(planType === 'monthly' ? prices.monthly : prices.annually)}{' '}
            <span>
              {planType === 'monthly' ? t("innerLayout.paymobPro.pricingPlanMonthly") : t("innerLayout.paymobPro.pricingPlanAnnually")}
            </span>
          </div>
          <div className={styles['card__content__body__list']}>
            <span>
              {description}
            </span>
            <ul>
              {includes.map((feature, id) => {
                const hideLastChild = hideCheckIcon && id === includes.length - 1;

                return (
                  <li
                    key={id}
                    data-hide-check-icon={hideLastChild}
                  >
                    {Check}
                    {FormatCurrencyForDisplay(feature)}
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>

      {note &&
        <div className={styles['card__note']}>
          {FormatCurrencyForDisplay(t('innerLayout.paymobPro.pricingPlanNote'))}
        </div>
      }

      <div className={styles['card__footer']}>
        <Button
          variant="outlined"
          color="primary"
          size="md"
          text={`${t('innerLayout.paymobPro.pricingChoosePlan')} ${title}`}
          disabled={true}
        />
      </div>

      {recommended &&
        <div className={styles['card__recommended-plan']}>
          {t('innerLayout.paymobPro.pricingRecommended')}
        </div>
      }
    </div>
  );
};
